"use strict";
import { emailService } from "../services/email_service";
import DisablingButton from "../components/disabling_button";
import LinkedStateMixin from "react-addons-linked-state-mixin";
var MarkEmailCompleteView = React.createClass({
  mixins: [LinkedStateMixin],
  getInitialState: function() {
    return { includeException: false };
  },
  render: function() {
    window.email = this.props.email;
    return /* @__PURE__ */ React.createElement("div", { className: "modal__medium-container reply__mark-complete" }, /* @__PURE__ */ React.createElement("div", { className: "row" }, /* @__PURE__ */ React.createElement("div", { className: "small-10 column" }, /* @__PURE__ */ React.createElement("h3", null, "Ignore this entry.")), /* @__PURE__ */ React.createElement("div", { className: "small-10 column" }, /* @__PURE__ */ React.createElement("p", null, "Ignoring this entry will remove it from your dashboard.")), this.possibleCompletionOptions(), /* @__PURE__ */ React.createElement("div", { className: "small-10 column" }, /* @__PURE__ */ React.createElement(
      DisablingButton,
      {
        disabled: this.state.completing,
        disabledText: "Completing...",
        onClick: this.markComplete,
        className: "button--confirmation"
      },
      "Ignore This Entry"
    ), " \xA0", /* @__PURE__ */ React.createElement("span", { className: "button--cancel-wrapper" }, "or", /* @__PURE__ */ React.createElement(
      "button",
      {
        className: "button--cancel",
        onClick: this.props.onCancel
      },
      "cancel"
    )))));
  },
  possibleCompletionOptions: function() {
    var email = this.props.email;
    if (email.parent && _.some(email.parent.exceptioned_items, function(item) {
      return item.state !== "complete";
    })) {
      return /* @__PURE__ */ React.createElement("div", { className: "small-10 column" }, /* @__PURE__ */ React.createElement("input", { type: "checkbox", checkedLink: this.linkState("includeException") }), " Ignore the original invoice and remove from my dashboard as well.");
    }
  },
  markComplete: function() {
    this.setState({ completing: true });
    emailService.markComplete(this.props.email, !this.state.includeException, null, true).then(function() {
      this.props.onMarkCompleteFinished();
      this.setState({ completing: false });
    }.bind(this));
  }
});
export default MarkEmailCompleteView;
